import React, { useState, useRef } from "react";
import api, { fileUrl } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Upload, X } from "lucide-react";
import { toast } from "sonner";

export default function ImageUpload({ value, onChange, label = "Image", testid = "image-upload" }) {
  const [busy, setBusy] = useState(false);
  const ref = useRef(null);

  const upload = async (file) => {
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const r = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(r.data.url);
      toast.success("Image uploaded");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Upload failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div>
      <div className="text-ink-secondary text-xs font-heading uppercase tracking-widest mb-2">{label}</div>
      <div className="flex items-center gap-3">
        <div className="w-16 h-16 rounded-sm bg-navy-deep border border-navy-border grid place-items-center overflow-hidden">
          {value ? <img src={fileUrl(value)} alt="" className="w-full h-full object-cover" />
            : <Upload size={20} className="text-ink-muted" />}
        </div>
        <input
          ref={ref}
          type="file"
          accept="image/*"
          className="hidden"
          data-testid={`${testid}-file`}
          onChange={(e) => upload(e.target.files?.[0])}
        />
        <Button
          type="button"
          onClick={() => ref.current?.click()}
          disabled={busy}
          variant="outline"
          data-testid={`${testid}-btn`}
          className="bg-transparent border-navy-border text-white hover:bg-navy-surface font-heading uppercase tracking-widest text-xs rounded-sm"
        >
          {busy ? "Uploading…" : value ? "Change" : "Upload"}
        </Button>
        {value && (
          <Button
            type="button"
            variant="ghost"
            onClick={() => onChange(null)}
            data-testid={`${testid}-clear`}
            className="text-ink-secondary hover:text-court-red hover:bg-transparent"
          >
            <X size={16} />
          </Button>
        )}
      </div>
    </div>
  );
}
